import { authLoginPath } from '#/modules/auth/routing/auth.paths';
import { HttpError } from '#/utils/HttpError';
import { addFlashForNextPageLoad } from '#/zustand-stores/flashesStore';

import { parseJsonResponse } from './parseJsonResponse';

export function handleErrors(
  status: number,
  url: string,
  resolve: () => void,
  reject: () => void,
  options: { skipRedirects?: boolean; retriesRemaining?: number } = {},
) {
  if (status > 199 && status < 300) {
    resolve();
    return;
  }

  if (options.skipRedirects) {
    reject();
    return;
  }

  let homePath = `/`;

  if (window.location.pathname.startsWith('/fair')) {
    homePath = '/fair';
  }

  if (/\/[^/]/.test(url)) {
    // don't redirect on 401/403 for algolia requests
    if (status === 401) {
      window.location.href = authLoginPath.with({ auth_required: 1 });
      return;
    }

    if (status === 403) {
      addFlashForNextPageLoad('Forbidden', 'error');
      window.location.href = homePath;
      return;
    }

    const { retriesRemaining } = options;
    if (
      (status === 408 ||
        /* Request Timeout */
        status >= 500) &&
      retriesRemaining
    ) {
      setTimeout(() => {
        // oxlint-disable-next-line @typescript-eslint/no-use-before-define
        getJsonInternal(url, resolve, reject, retriesRemaining - 1);
      }, 1000);
      return;
    }

    reject();
    return;
  }

  reject();
}

export function getJsonInternal<TData>(
  url: string,
  resolve: (data: TData) => void,
  reject: (error: Error) => void,
  retriesRemaining: number,
) {
  const xhr = new XMLHttpRequest();
  xhr.addEventListener('load', () => {
    handleErrors(
      xhr.status,
      url,
      // TODO: fix types
      // oxlint-disable-next-line @typescript-eslint/no-unsafe-argument
      () => resolve(parseJsonResponse(xhr, reject)),
      () => reject(new HttpError('GET', url, xhr)),
      {
        retriesRemaining,
      },
    );
  });
  xhr.open('GET', url, true);
  xhr.setRequestHeader('Accept', 'application/json');
  xhr.send();
}
